<div class="manual-wrap">
  @if (loading) {
    <div class="state-message">Loading manual…</div>
  } @else if (loadError) {
    <div class="state-message state-message--error">
      Couldn't load the manual. Please try again later.
    </div>
  } @else {
    <div class="manual-body">

      <!-- ── Sidebar: table of contents + search ────── -->
      <aside class="manual-sidebar">
        <div class="search-box">
          <span class="material-icons search-icon">search</span>
          <input
            type="text"
            placeholder="Search the manual…"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            (keydown.escape)="clearSearch()"
          />
          @if (searchTerm) {
            <button type="button" class="clear-btn" (click)="clearSearch()" aria-label="Clear search">
              <span class="material-icons">close</span>
            </button>
          }
        </div>

        @if (searchTerm) {
          <div class="search-status">
            @if (matches.length) {
              <span>{{ currentMatchIndex + 1 }} of {{ matches.length }}</span>
              <button type="button" (click)="prevMatch()" aria-label="Previous match">
                <span class="material-icons">keyboard_arrow_up</span>
              </button>
              <button type="button" (click)="nextMatch()" aria-label="Next match">
                <span class="material-icons">keyboard_arrow_down</span>
              </button>
            } @else {
              <span>No matches</span>
            }
          </div>
        }

        <nav class="toc">
          <div class="toc-label">Sections</div>
          @for (entry of toc; track entry.id) {
            <button type="button" class="toc-item" (click)="jumpTo(entry.id)">
              {{ entry.label }}
            </button>
          }
        </nav>
      </aside>

      <!-- ── Manual content ──────────────────────────── -->
      <iframe
        #manualFrame
        [srcdoc]="safeHtml"
        (load)="onIframeLoad()"
        class="manual-frame"
        title="Partner Portal Manual"
      ></iframe>

    </div>
  }
</div>
